import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDistanceToNowStrict } from "date-fns";
import { Link } from "@quintype/components";
import get from "lodash/get";

import { getCollection } from "../../helper/api";
import CloseIcon from "../icons/close";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";

import "./latest-button.m.css";

const LatestButton = () => {
  const [stories, setStories] = useState([]);
  const [openStories, setOpenStories] = useState(false);
  const latestTenStories = useSelector((state) => get(state, ["storyReducer", "latestTenStories"], []));
  useEffect(() => latestTenStories && setStories(latestTenStories), [latestTenStories]);

  const handleClick = async () => {
    if (stories?.length) {
      setOpenStories(!openStories);
    } else {
      await getCollection("latest-news", 0, 10).then(async (res) => await setStories(res));
      setOpenStories(!openStories);
    }
  };

  return (
    <div styleName="latest-news-wrapper">
      <button styleName="latest-button" onClick={handleClick}>
        LATEST
      </button>
      {stories
        ? openStories && (
            <>
              <div styleName="triangle"></div>
              <div styleName="stories-wrapper">
                <div>
                  <div styleName="stories-header">
                    <span styleName="header-title">Latest News</span>
                    <div styleName="close-stories" onClick={() => setOpenStories(false)}>
                      <CloseIcon fill="#000" />
                    </div>
                  </div>
                  <div styleName="story-cards-wrapper">
                    {stories.length
                      ? stories?.slice(0, 10).map((story, index) => (
                          <div key={index} styleName="story-card">
                            <Link href={`/${story.slug}`}>
                              <span styleName="headline">{story.headline}</span>
                            </Link>
                            <div styleName="timestamp">
                              <div styleName="date">
                                {formatDistanceToNowStrict(new Date(story && story["last-published-at"]))} ago
                              </div>
                            </div>
                          </div>
                        ))
                      : null}
                    <Link href={`/latest-news`} styleName="stories-footer">
                      <span>See all</span>
                      <div styleName="see-all-stories">
                        <SvgIconHandler type="rightarrowblue" height="24" width="24" />
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </>
          )
        : null}
    </div>
  );
};

export default LatestButton;
